import ConexionPush from "@/api/ConexionPush.js";

/**
 *  Verifica que el navegador soporte el serviceWorkwer y push PushManager
 */
function isPushNotificationSupported() {
  return "serviceWorker" in navigator && "PushManager" in window;
}

/**
 * Esto hace que al usuario le muestre la ventana para aceptar concentimiento de recibir notificaciones y regresa su respuesta puede ser:   granted, default o denied
 */
function initializePushNotifications() {
  // request user grant to show notification
  return Notification.requestPermission(function(result) {
    return result;
  });
}

/**
 * Registra el serviceWorker que es un archivo js que se "instala" en el navegador y corre en segundo plano este archivo se sirve desde el edge server.
 */
function registerServiceWorker() {
  navigator.serviceWorker.register("/sw.js").then(function() {
  });
}


/**
 * 
 * Usando el serviceWorker registrado   se crea una suscripción de        notificaciones push y la regresa
 * 
 * @returns {function}  subscription   
 */

async function createNotificationSubscription() {
  //wait for service worker installation to be ready, and then
  let key = await GetKey();
  if(key == null) return

  return navigator.serviceWorker.ready.then(function(serviceWorker) {
    // subscribe and return the subscription
    return serviceWorker.pushManager
    .subscribe({
      userVisibleOnly: true,
      applicationServerKey: key
    })
    .then(function(subscription) {
      console.log('%c Se ha suscrito usuario. ', ' color:  #2e86c1 ')
      return subscription;
    });
  });
}

/**
 * En caso de ya estar suscrito solo regresa la suscripcion
 * @returns {function}  pushSubscription     
 */
function getUserSubscription() {
  //wait for service worker installation to be ready, and then
  return navigator.serviceWorker.ready
    .then(function(serviceWorker) {
      return serviceWorker.pushManager.getSubscription();
    })
    .then(function(pushSubscription) {
      return pushSubscription;
    });
}
/**
  Pide  al servidor de notificaciones la key para la suscripcion y la retorna
*/
const GetKey = async () => {
  let res = await ConexionPush({
    evento: "key",
    body: {}
  });
  
  return (res && res.data && res.data.vapid_key) ? res.data.vapid_key : null; 
};
/*
  Envia la suscripcion al servidor push junto con el nombre del proyecto de push en este caso es eordering y el correo identificador con el que se desea buscar en querys.
*/
const sendSubscriptionToPushServer = async (data) => {

  let { subscrition, base, email, bases } = data
  console.log("SendSubscriptionPushServer")
  console.log(data)

  subscrition.proyecto = "eordering_nuevo_login"
  subscrition.correo =  email ? email : ""
  // let bases_str = localStorage.getItem('dbs') ? localStorage.getItem('dbs') : "xdy_01";
  // let bases_arr = bases_str.split(",") ;
  // let bases = (bases_arr.length > 1) ? bases_arr : bases_arr[0]
  let res = await ConexionPush({
    evento: "registrar",
    body: {
      suscripcion: subscrition,
      proyecto : "eordering_nuevo_login",
      correo   : email ? email : "",
      base     : base,
      bases: bases,
      actualiza_registro: true
    } 
  });
  return res;    
};


export {
  isPushNotificationSupported,
  initializePushNotifications,
  registerServiceWorker,
  createNotificationSubscription,
  getUserSubscription,
  sendSubscriptionToPushServer
};
